import {
  EditProductPriceForm,
  ProductPriceFormSchema,
  ProductPriceFormValues,
} from '@airship-platform/airship-proposal';
import { BaseDialog, FlexBox } from '@airship-platform/jam-web/components';
import { zodResolver } from '@hookform/resolvers/zod';
import Box from '@mui/material/Box';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

interface EditProductPriceModalProps {
  prices: ProductPriceFormValues[];
  defaultValues: ProductPriceFormValues;
  hasMembership: boolean;
  title: string;
  isModalOpen: boolean;
  isLoading: boolean;
  onModalClose: () => void;
  onSubmitPrice: (price: ProductPriceFormValues) => void;
}

const FORM_ID = 'edit-product-price-form';

const EditProductPriceModal: React.FC<EditProductPriceModalProps> = ({
  prices,
  defaultValues,
  hasMembership,
  title,
  isModalOpen,
  isLoading,
  onModalClose,
  onSubmitPrice,
}) => {
  const productPriceForm = useForm<ProductPriceFormValues>({
    defaultValues,
    resolver: zodResolver(ProductPriceFormSchema),
  });

  return (
    <BaseDialog
      fullWidth={false}
      open={isModalOpen}
      onClose={onModalClose}
      title={title}
      footerAction={{
        left: {
          children: 'Cancel',
          onClick: onModalClose,
          type: 'button',
          color: 'softGold',
        },
        right: {
          form: FORM_ID,
          type: 'submit',
          children: 'Save price',
          disabled: isLoading,
        },
      }}
    >
      <Box
        component={'form'}
        id={FORM_ID}
        onSubmit={productPriceForm.handleSubmit(onSubmitPrice)}
        autoComplete="off"
        noValidate
      >
        <FormProvider {...productPriceForm}>
          <FlexBox
            alignItems={'center'}
            flexDirection={'column'}
            justifyContent={'center'}
            gap={4}
          >
            <EditProductPriceForm
              prices={prices}
              isDisabled={isLoading}
              hasMembership={hasMembership}
            />
          </FlexBox>
        </FormProvider>
      </Box>
    </BaseDialog>
  );
};

export default EditProductPriceModal;
